import React, { Component } from "react";
import { observer, inject } from "mobx-react";

class UserPanel extends Component {
  render() {
    const { stores } = this.props;
    const user = stores.currentUser.user;

    let userRoleName = "";
    if (user) {
      switch (user.RoleId) {
        case 1:
          userRoleName = "Contract manager";
          break;
        case 2:
          userRoleName = "i-Theses Administrator";
          break;
        default:
          userRoleName = "Standard user";
      }
    }

    return (
      <div className="col-sm-6">
        <div className="well">
          <div className="row">
            <div className="col-sm-6">
              <h2>{user.Name}</h2>
              <p>{user.Email}</p>
              <p>{userRoleName}</p>
              <a href={"#user-detail?id=" + user.Id}>Edit</a>
            </div>
            <div className="col-sm-6">
              <img className="home-icon" src="images/users.png" alt="user" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default inject("stores")(observer(UserPanel));



// WEBPACK FOOTER //
// ./src/Components/UserPanel/UserPanel.js